import { observer } from 'mobx-react-lite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';

import {
  BranchWorkerAccountTypes,
  PayoutMethod,
} from 'us-web-services';
import { Button, ButtonType } from '../../components';
import { useDependencies } from '../../dependencies';
import { AcceptingPaymentToggle } from './AcceptingPaymentToggle';
import { MembershipPayment } from './MembershipPayment';
import { PayoutFaq } from './PayoutFaq';

interface BranchActiveProps {
  payoutMethod: PayoutMethod;
}

export const BranchActive = observer(({ payoutMethod }: BranchActiveProps): JSX.Element => {
  const { t } = useSharedTranslation(namespaces.caregiver);
  const { services, stores } = useDependencies();
  const { config } = services;
  const { sitter: { sitter } } = stores;
  const acceptsCreditCards: boolean = sitter.acceptsCreditCards || false;

  const handleBranchClick = (): void => {
    const branchUrl = payoutMethod.accountType === BranchWorkerAccountTypes.WALLET ? config.BRANCH_WALLET_URL : config.BRANCH_DIRECT_URL;

    window.open(branchUrl, '_blank', 'noreferrer');
  };

  return (
    <article className='py-6 h-fit'>
      <div className='w-full'>
        <div className='flex flex-col md:flex-row'>
          <div className='md:w-1/2'>
            <h1 className='text-2xl font-semibold'>{t('pages.sitter.payout.title')}</h1>
            <div className='mb-10 border-2 rounded-2xl p-3'>
              <div className='mb-2.5 font-bold'>{t('pages.sitter.payout.active.title')}</div>
              <hr />
              {acceptsCreditCards ? (
                <>
                  <div className='font-semibold my-2'>
                    {t('pages.sitter.payout.active.heading1')}
                  </div>
                  <div className='mb-2'>
                    {t('pages.sitter.payout.active.body1Branch')}
                  </div>
                  <div className='mb-3'>
                    {t('pages.sitter.payout.active.body2Branch')}
                  </div>
                  <div className='mb-3'>
                    {t('pages.sitter.payout.active.body3Branch')}
                  </div>
                </>
              ) : (
                <>
                  <div className='font-semibold my-2'>
                    {t('pages.sitter.payout.active.declined.heading')}
                  </div>
                  <div className='mb-2'>
                    {t('pages.sitter.payout.active.declined.body1')}
                  </div>
                  <div className='mb-3'>
                    {t('pages.sitter.payout.active.declined.body2')}
                  </div>
                </>
              )}
              <Button
                className='mt-3'
                buttonType={ButtonType.primary}
                onClick={handleBranchClick}
              >
                {t('pages.sitter.payout.navigateToBranch')}
              </Button>
              <div className='text-gray ml-0.5 mt-3'>
                <FontAwesomeIcon icon={faLock} className='mr-2'/>{t('pages.sitter.payout.securedBranch')}
              </div>
            </div>
            <div className='md:hidden mb-10 md:p-14 md:w-1/2'>
              <PayoutFaq />
            </div>
            <div className='mb-10 border-2 rounded-2xl p-3'>
              <AcceptingPaymentToggle />
            </div>
            <MembershipPayment />
          </div>
          <div className='hidden md:block mb-10 md:p-14 md:w-1/2'>
            <PayoutFaq />
          </div>
        </div>
      </div>
    </article>
  );
});
